import { motion } from "framer-motion";

export const scrollToId = (id) => {
  const el = typeof id === "string" && id.startsWith("#") ? id : `#${id}`;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -80, duration: 1.2 });
  } else {
    document.querySelector(el)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const prefillArea = (slug) => {
  window.dispatchEvent(new CustomEvent("juris:prefill-area", { detail: slug }));
};

const ease = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, dark = false }) {
  return (
    <p
      className={`text-xs font-medium tracking-[0.14em] ${
        dark ? "text-brand-400" : "text-brand-600"
      }`}
    >
      {children}
    </p>
  );
}

export const INPUT_CLASS =
  "w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 transition-colors duration-200 focus:border-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-600/15";